module.exports = __webpack_public_path__ + "img/shopping-bag.40ae9be2.svg";